<template>
    <div>
        <p v-if="!invitations.items.length">Keine ausstehenden Einladungen</p>
        <div v-else>
          <p>Diese Kolleg*innen wurden bereits eingeladen:</p>
          <b-table :fields="invitations.fields" :items="invitations.items" responsive="">
            <template v-slot:cell(buttons)="row">
              <div class="text-right">
                <b-button variant="danger" size="sm" v-on:click="confirmDelete(row.index)">
                  <font-awesome-icon icon="trash-alt"></font-awesome-icon>
                </b-button>

                <b-button variant="primary" size="sm" v-on:click="confirmResend(row.index)">
                  Erneut senden
                </b-button>
              </div>
            </template>
          </b-table>
        </div>
    </div>

</template>

<script>
export default {
  name: 'InvitesTable',
  data: () => {
    return {
      invitations: {
        items: [],
        fields: [
          {key: 'name', label: 'Name'},
          {key: 'email', label: 'Email'},
          {key: 'buttons', label: ''}
        ]
      }
    }
  },

  mounted: function () {
    this.loadInvites()
  },

  methods: {
    loadInvites: function () {
      this.axios.get('/schools/me/invitations').then(rsp => {
        rsp.data.forEach(invite => {
          this.invitations.items.push({
            token: invite.token,
            email: invite.email,
            name: invite.name
          })
        })
      })
    },

    confirmDelete: function (idx) {
      this.$eventHub.$emit(
        'confirm',
        'Einladung an ' + this.invitations.items[idx].name + ' löschen?',
        'Einladung löschen',
        () => {
          this.delete(idx)
        }
      )
    },

    confirmResend: function (idx) {
      let invitation = this.invitations.items[idx]
      this.$eventHub.$emit(
        'confirm',
        'Einladung an ' + invitation.name + ' erneut senden?',
        'Erneut einladen',
        () => {
          this.$emit('invite', invitation)
        }
      )
    },

    delete: function (idx) {
      this.axios.delete('/users/invite/' + this.invitations.items[idx].token)
        .then(() => {
          this.invitations.items.splice(idx, 1)
          this.$eventHub.$emit('info', 'Einladung gelöscht')
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/schools/InvitesTable.vue